"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var CBOR = require("@wireapp/cbor");
var ClassUtil_1 = require("../util/ClassUtil");
var MemoryUtil_1 = require("../util/MemoryUtil");
var DecodeError_1 = require("../errors/DecodeError");
var DecryptError_1 = require("../errors/DecryptError");
var ProteusError_1 = require("../errors/ProteusError");
var SessionState_1 = require("./SessionState");
var IdentityKey_1 = require("../keys/IdentityKey");
var IdentityKeyPair_1 = require("../keys/IdentityKeyPair");
var KeyPair_1 = require("../keys/KeyPair");
var PreKey_1 = require("../keys/PreKey");
var PublicKey_1 = require("../keys/PublicKey");
var CipherMessage_1 = require("../message/CipherMessage");
var PreKeyMessage_1 = require("../message/PreKeyMessage");
var SessionTag_1 = require("../message/SessionTag");
var Session = (function () {
    function Session() {
        this.counter = 0;
        this.version = 1;
        this.local_identity = new IdentityKeyPair_1.default();
        this.pending_prekey = null;
        this.remote_identity = new IdentityKey_1.default();
        this.session_states = {};
        this.session_tag = new SessionTag_1.default();
    }
    Session.init_from_prekey = function (local_identity, remote_pkbundle) {
        return __awaiter(this, void 0, void 0, function () {
            var alice_base, state, session_tag, session;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, KeyPair_1.default.new()];
                    case 1:
                        alice_base = _a.sent();
                        return [4, SessionState_1.default.init_as_alice(local_identity, alice_base, remote_pkbundle)];
                    case 2:
                        state = _a.sent();
                        session_tag = SessionTag_1.default.new();
                        session = ClassUtil_1.default.new_instance(this);
                        session.session_tag = session_tag;
                        session.local_identity = local_identity;
                        session.remote_identity = remote_pkbundle.identity_key;
                        session.pending_prekey = [remote_pkbundle.prekey_id, alice_base.public_key];
                        session.session_states = {};
                        session._insert_session_state(session_tag, state);
                        return [2, session];
                }
            });
        });
    };
    Session.init_from_message = function (our_identity, prekey_store, envelope) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var pkmsg = (function () {
                if (envelope.message instanceof CipherMessage_1.default) {
                    throw new DecryptError_1.default.InvalidMessage("Can't initialise a session from a CipherMessage.", DecryptError_1.default.CODE.CASE_201);
                }
                else if (envelope.message instanceof PreKeyMessage_1.default) {
                    return envelope.message;
                }
                else {
                    throw new DecryptError_1.default.InvalidMessage('Unknown message format: The message is neither a "CipherMessage" nor a "PreKeyMessage".', DecryptError_1.default.CODE.CASE_202);
                }
            })();
            var session = ClassUtil_1.default.new_instance(Session);
            session.session_tag = pkmsg.message.session_tag;
            session.local_identity = our_identity;
            session.remote_identity = pkmsg.identity_key;
            session.pending_prekey = null;
            session.session_states = {};
            return session
                ._new_state(prekey_store, pkmsg)
                .then(function (state) { return __awaiter(_this, void 0, void 0, function () {
                var plain, _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4, state.decrypt(envelope, pkmsg.message)];
                        case 1:
                            plain = _c.sent();
                            session._insert_session_state(pkmsg.message.session_tag, state);
                            if (!(pkmsg.prekey_id < PreKey_1.default.MAX_PREKEY_ID)) return [3, 3];
                            _b = (_a = MemoryUtil_1.default).zeroize;
                            return [4, prekey_store.get_prekey(pkmsg.prekey_id)];
                        case 2:
                            _b.apply(_a, [_c.sent()]);
                            return [2, prekey_store
                                    .remove(pkmsg.prekey_id)
                                    .then(function () { return resolve([session, plain]); })
                                    .catch(function (error) {
                                    reject(new DecryptError_1.default.PrekeyNotFound("Could not delete PreKey: " + error.message, DecryptError_1.default.CODE.CASE_203));
                                })];
                        case 3: return [2, resolve([session, plain])];
                    }
                });
            }); })
                .catch(reject);
        });
    };
    Session.prototype._new_state = function (pre_key_store, pre_key_message) {
        var _this = this;
        return pre_key_store.get_prekey(pre_key_message.prekey_id).then(function (pre_key) {
            if (pre_key) {
                return SessionState_1.default.init_as_bob(_this.local_identity, pre_key.key_pair, pre_key_message.identity_key, pre_key_message.base_key);
            }
            throw new ProteusError_1.default("Unable to find PreKey ID \"" + pre_key_message.prekey_id + "\" in PreKey store \"" + pre_key_store.constructor.name + "\".", ProteusError_1.default.CODE.CASE_101);
        });
    };
    Session.prototype._insert_session_state = function (tag, state) {
        if (this.session_states.hasOwnProperty(tag.toString())) {
            this.session_states[tag.toString()].state = state;
        }
        else {
            if (this.counter >= Number.MAX_SAFE_INTEGER) {
                this.session_states = {};
                this.counter = 0;
            }
            this.session_states[tag.toString()] = {
                idx: this.counter,
                state: state,
                tag: tag,
            };
            this.counter++;
        }
        if (this.session_tag.toString() !== tag.toString()) {
            this.session_tag = tag;
        }
        var obj_size = function (obj) { return Object.keys(obj).length; };
        if (obj_size(this.session_states) < Session.MAX_SESSION_STATES) {
            return;
        }
        return this._evict_oldest_session_state();
    };
    Session.prototype._evict_oldest_session_state = function () {
        var _this = this;
        var oldest = Object.keys(this.session_states)
            .filter(function (obj) { return obj.toString() !== _this.session_tag.toString(); })
            .reduce(function (lowest, obj, index) {
            return _this.session_states[obj].idx < _this.session_states[lowest].idx ? obj.toString() : lowest;
        });
        MemoryUtil_1.default.zeroize(this.session_states[oldest]);
        delete this.session_states[oldest];
    };
    Session.prototype.get_local_identity = function () {
        return this.local_identity.public_key;
    };
    Session.prototype.encrypt = function (plaintext) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var session_state = _this.session_states[_this.session_tag.toString()];
            if (!session_state) {
                return reject(new ProteusError_1.default("Could not find session for tag '" + (_this.session_tag || '').toString() + "'.", ProteusError_1.default.CODE.CASE_102));
            }
            return resolve(session_state.state.encrypt(_this.local_identity.public_key, _this.pending_prekey, _this.session_tag, plaintext));
        });
    };
    Session.prototype.decrypt = function (prekey_store, envelope) {
        var _this = this;
        return new Promise(function (resolve) {
            var msg = envelope.message;
            if (msg instanceof CipherMessage_1.default) {
                return resolve(_this._decrypt_cipher_message(envelope, msg));
            }
            else if (msg instanceof PreKeyMessage_1.default) {
                var actual_fingerprint = msg.identity_key.fingerprint();
                var expected_fingerprint = _this.remote_identity.fingerprint();
                if (actual_fingerprint !== expected_fingerprint) {
                    var message = "Fingerprints do not match: We expected '" + expected_fingerprint + "', but received '" + actual_fingerprint + "'.";
                    throw new DecryptError_1.default.RemoteIdentityChanged(message, DecryptError_1.default.CODE.CASE_204);
                }
                return resolve(_this._decrypt_prekey_message(envelope, msg, prekey_store));
            }
            throw new DecryptError_1.default('Unknown message type.', DecryptError_1.default.CODE.CASE_200);
        });
    };
    Session.prototype._decrypt_prekey_message = function (envelope, msg, prekey_store) {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this._decrypt_cipher_message(envelope, msg.message); })
            .catch(function (error) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (error instanceof DecryptError_1.default.InvalidSignature ||
                    error instanceof DecryptError_1.default.InvalidMessage) {
                    return [2, this._new_state(prekey_store, msg).then(function (state) { return __awaiter(_this, void 0, void 0, function () {
                            var plaintext, _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0: return [4, state.decrypt(envelope, msg.message)];
                                    case 1:
                                        plaintext = _c.sent();
                                        if (!(msg.prekey_id !== PreKey_1.default.MAX_PREKEY_ID)) return [3, 3];
                                        _b = (_a = MemoryUtil_1.default).zeroize;
                                        return [4, prekey_store.get_prekey(msg.prekey_id)];
                                    case 2:
                                        _b.apply(_a, [_c.sent()]);
                                        prekey_store.remove(msg.prekey_id);
                                        _c.label = 3;
                                    case 3:
                                        this._insert_session_state(msg.message.session_tag, state);
                                        this.pending_prekey = null;
                                        return [2, plaintext];
                                }
                            });
                        }); })];
                }
                throw error;
            });
        }); });
    };
    Session.prototype._decrypt_cipher_message = function (envelope, msg) {
        return __awaiter(this, void 0, void 0, function () {
            var state, session_state, plaintext;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        state = this.session_states[msg.session_tag.toString()];
                        if (!state) {
                            throw new DecryptError_1.default.InvalidMessage("Local session not found for message session tag '" + msg.session_tag + "'.", DecryptError_1.default.CODE.CASE_205);
                        }
                        session_state = SessionState_1.default.deserialise(state.state.serialise());
                        return [4, session_state.decrypt(envelope, msg)];
                    case 1:
                        plaintext = _a.sent();
                        this.pending_prekey = null;
                        this._insert_session_state(msg.session_tag, session_state);
                        return [2, plaintext];
                }
            });
        });
    };
    Session.prototype.serialise = function () {
        var encoder = new CBOR.Encoder();
        this.encode(encoder);
        return encoder.get_buffer();
    };
    Session.deserialise = function (local_identity, buf) {
        var decoder = new CBOR.Decoder(buf);
        return this.decode(local_identity, decoder);
    };
    Session.prototype.encode = function (encoder) {
        encoder.object(6);
        encoder.u8(0);
        encoder.u8(this.version);
        encoder.u8(1);
        this.session_tag.encode(encoder);
        encoder.u8(2);
        this.local_identity.public_key.encode(encoder);
        encoder.u8(3);
        this.remote_identity.encode(encoder);
        encoder.u8(4);
        if (this.pending_prekey) {
            encoder.object(2);
            encoder.u8(0);
            encoder.u16(this.pending_prekey[0]);
            encoder.u8(1);
            this.pending_prekey[1].encode(encoder);
        }
        else {
            encoder.null();
        }
        encoder.u8(5);
        encoder.object(Object.keys(this.session_states).length);
        for (var index in this.session_states) {
            var state = this.session_states[index];
            state.tag.encode(encoder);
            state.state.encode(encoder);
        }
    };
    Session.decode = function (local_identity, decoder) {
        var self = ClassUtil_1.default.new_instance(this);
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0: {
                    self.version = decoder.u8();
                    break;
                }
                case 1: {
                    self.session_tag = SessionTag_1.default.decode(decoder);
                    break;
                }
                case 2: {
                    var identity_key = IdentityKey_1.default.decode(decoder);
                    if (local_identity.public_key.fingerprint() !== identity_key.fingerprint()) {
                        throw new DecodeError_1.default.LocalIdentityChanged(null, DecodeError_1.default.CODE.CASE_300);
                    }
                    self.local_identity = local_identity;
                    break;
                }
                case 3: {
                    self.remote_identity = IdentityKey_1.default.decode(decoder);
                    break;
                }
                case 4: {
                    switch (decoder.optional(function () { return decoder.object(); })) {
                        case null:
                            self.pending_prekey = null;
                            break;
                        case 2:
                            self.pending_prekey = [];
                            for (var key = 0; key <= 1; ++key) {
                                switch (decoder.u8()) {
                                    case 0:
                                        self.pending_prekey[0] = decoder.u16();
                                        break;
                                    case 1:
                                        self.pending_prekey[1] = PublicKey_1.default.decode(decoder);
                                        break;
                                }
                            }
                            break;
                        default:
                            throw new DecodeError_1.default.InvalidType(null, DecodeError_1.default.CODE.CASE_301);
                    }
                    break;
                }
                case 5: {
                    self.session_states = {};
                    for (var idx = 0, ref = decoder.object() - 1, subindex = 0; 0 <= ref ? subindex <= ref : subindex >= ref; idx = 0 <= ref ? ++subindex : --subindex) {
                        var tag = SessionTag_1.default.decode(decoder);
                        self.session_states[tag.toString()] = {
                            idx: idx,
                            state: SessionState_1.default.decode(decoder),
                            tag: tag,
                        };
                    }
                    break;
                }
                default: {
                    decoder.skip();
                }
            }
        }
        return self;
    };
    Session.MAX_RECV_CHAINS = 5;
    Session.MAX_SESSION_STATES = 100;
    return Session;
}());
exports.Session = Session;
exports.default = Session;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/session/Session.js
// module id = 66
// module chunks = 0 1